export function buildingDrawRect({
  sourceWidth,
  sourceHeight,
  tileX,
  tileY,
  tileSize,
}: {
  sourceWidth: number;
  sourceHeight: number;
  tileX: number;
  tileY: number;
  tileSize: number;
}): { x: number; y: number; width: number; height: number } {
  const width = sourceWidth > 0 ? sourceWidth : tileSize;
  const height = sourceHeight > 0 ? sourceHeight : tileSize;
  return {
    x: tileX * tileSize + (tileSize - width) / 2,
    y: tileY * tileSize + (tileSize - height) / 2,
    width,
    height,
  };
}

export function drawBuildingImage({
  ctx,
  img,
  tileX,
  tileY,
  tileSize,
  flipX = false,
}: {
  ctx: CanvasRenderingContext2D;
  img: HTMLImageElement;
  tileX: number;
  tileY: number;
  tileSize: number;
  flipX?: boolean;
}): void {
  const rect = buildingDrawRect({
    sourceWidth: img.naturalWidth,
    sourceHeight: img.naturalHeight,
    tileX,
    tileY,
    tileSize,
  });
  ctx.imageSmoothingEnabled = false;
  if (flipX) {
    ctx.save();
    ctx.translate(rect.x + rect.width, rect.y);
    ctx.scale(-1, 1);
    ctx.drawImage(img, 0, 0, rect.width, rect.height);
    ctx.restore();
    return;
  }
  ctx.drawImage(img, rect.x, rect.y, rect.width, rect.height);
}
